// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".tour-price-card.box-border{border:1px solid #bdc6f3 !important}\n", "",{"version":3,"sources":["/app/src/component/specific/tourPriceCard/tourPriceCard.scss"],"names":[],"mappings":"AAAA,4BAEI,mCAA+C","file":"tourPriceCard.scss","sourcesContent":[".tour-price-card {\n  &.box-border {\n    border: 1px solid rgb(189, 198, 243) !important;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
